import print from '../../api/moudles/print.js'
import order from '../../api/moudles/order.js'
import config from '../../pages/allOrders/config.js'
import {
	Message
} from 'element-ui'
import utils from '../../utils/utils.js'

import {
	SET_ITEMS,
	SET_TTP,
	SET_HAS_PRINTED,
	SET_HAS_PRINTED_READY,
	SET_SECONDE_PICKTIME,
	INIT_DATA,
	FAST_PRINT,
	UPDATA_PAGE,
	SHOW_LOADING,
	SET_LOGISTIC_FALSE,
	SENT_PPT
	
	
} from '../mutation-types'
import { cosh } from 'core-js/core/number'


const state = {
	orderList: [],
	buttonList: [],
	buttonMapList: [],
	activeList: [],
	success_list:[],
	error_list:[],
	orderUrl:'',
	totalNum:0,
	shopIds:[],
	isDone:false,
	falg:false,
	aleadyGenaratedNum:[],
	generateOrderId:[],
	successList:[],
	activeValue:null,
	activeIndex:null,
	aleadyGetlogist:false,
	packagelist:[],
	alreadyLoaded:false,
	orderList2:[],
	userFlags:[],
	flashPage:config.flagList,
	loading:false,
	loading_2:false,
	orderCount:[],
	numFlagId:false,
	fastPrintList:[],
	storeItemsInfo:[],
	storeItemsData:[],
	orderPointInfo:[],
	chooseOrderId:[],
	listTarget:[]
}

const getters = {

}

const actions = {
	cancelReview({state,commit},payload) {
		const p =new Promise((resolve) => {
			// state.orderCount.forEach(p => {
			// 	payload.payload.forEach(k => {
					
			// 		if(p.shop_id == k.shopId){
						
			// 			p.num =p.num - payload.payload.length
						
						
			// 		}
			// 	})
			// })

			console.log(state.orderCount)

			
		

			order
			.cancelReview(payload.payload) 
			.then(res => {
				if(res.code === 200) {
					Message({
						message: payload.text,
						type: 'success'
					})
					let list3=state.buttonMapList[8].find(item => item.isActive).value
					list3=list3.filter(p => {
						let arrlist=payload.payload.map(v => v.ordersn)
						return !arrlist.includes(p.orderId)
					})
					console.log('8874574',list)
					state.buttonMapList[8].find(item => item.isActive).value=list3
					console.log('list1',state.buttonMapList[8])
					resolve('success')
					
	
					state.orderList=state.orderList.filter(p => {
						let arrlist=payload.payload.map(v => v.ordersn)
						return !arrlist.includes(p.orderId)
					})
					state.buttonList = [];
					for (let i = 0; i < 8; i++) {
						state.buttonList.push(new Map())
						state.activeList.push('all')
					}
					state.orderList.forEach((order) => {
						
						order.shipByDate=utils.renderTimeDate(order.shipByDate)
						let shopIdMap = state.buttonList[0];
						let shopIdList = shopIdMap.get(order.storeId);
						if (shopIdList == null || shopIdList == "undifined") {
							shopIdList = [];
						}
						shopIdList.push(order);
						shopIdMap.set(order.storeId, shopIdList)
						state.buttonList[0] = shopIdMap;
						
					})
					let list = [];
					let flag = true;
					let firstShopId=0;
					state.buttonList[0].forEach((value, key) => {
						if(firstShopId==0){
							firstShopId=key
						}
						let active = (key == firstShopId)
						if (active == true) {
							flag = false
						}
						list.push({
							'key': key,
							'value': value,
							'isActive': active
						})
					})
					if (flag) {
						list[0].isActive = true;
					}
					state.buttonMapList.push(list);
					console.log('asfdsafg a', state.buttonList);
					console.log('state.orderCount',state.orderCount)
					state.orderCount.forEach(p => {
						payload.payload.forEach(k => {
							if(p.shop_id == k.ordersn){
								p.num =p.num - payload.payload.length
							}
						})
					})
					
					commit(SET_TTP, {
						orders: state.buttonList[0].get(firstShopId),
						index: 0
					})
					
				}
			})
		})

		return p
		
	},
	//仓库端获取每个订单的货物类型
	getGoodsTypeByStore({state},payload) {
		order
		.getGoodsTypeByStore(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('goodstype',res.data)
				if(res.data !== undefined){
					state.orderPointInfo=[res.data]
				}
			}
		})
		
	},
	//获取每个订单的积分扣减详情
	getGoodsType({state},payload) {
		order
		.getGoodsType(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('goodstype',res.data)
				if(res.data !== undefined){
					state.orderPointInfo=res.data
				}
				
			}
		})
		
	},
	//待处理页面，每个订单获取仓库信息
	getStoreItem({state,commit,dispatch}, payload) {
		order
		.getstoreitembyid(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('storeItem44',res.data)
			    state.storeItemsData=res.data
			}
		})
	},
	
	getstoreitembyid({state,commit,dispatch}, payload) {
		print
		.getOrderCount(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('获取订单的总数',res.data)
			}
		})
	},
	//获取各间商店的订单总数
	getOrderCount({state,commit,dispatch}, payload) {
		print
		.getOrderCount(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('获取订单的总数',res.data)
				state.orderCount=res.data
			}
		})
	},
	//更新旗帜描述
	updataUserFlageDesc({state,commit,dispatch}, payload) {
		print
		.updataUserFlageDesc(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('更新旗帜描述',res.data)
				console.log(state.flashPage)
				if(res.data.length > 0){
				   state.flashPage.forEach(p => {
					res.data.forEach(k => {
						if(p.colorId == k.color) {
							p.flagId=k.flagId
							p.desc=k.describe
						}
					})
				   })
				   
				}
			}
		})
	},
	//根据flagId获取旗帜信息
	getFlagById({state,commit,dispatch}, payload) {
		print
		.getFlagById(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('仓库端猎取旗帜信息',res.data)
				console.log('仓库端猎取旗帜信息',config.flagList)
				config.flagList.forEach(p => {
					if(p.colorId == res.data.color) {
						p.flagId=res.data.flagId
						p.desc=res.data.describe
						
					}
				})
				
				state.numFlagId=true
				setTimeout(() => {
					state.numFlagId=false
				},1000)
			}
		})
	},
	//获取用户旗帜
	getUserFlags({state,commit,dispatch}, payload) {
		print
		.getUserFlags(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('获取用户旗帜',res.data)
				state.userFlags=res.data
				console.log(state.flashPage)
				let userPos=JSON.parse(localStorage.getItem('userInfo')).userPos 
				if(userPos === 'SELLER') {
					let arr=[]
					   if(res.data.length === 0) {//如果检测到卖家帐号的下还没有的旗帜，就给这个用户创建旗帜
						   arr=state.flashPage.map(p => {
							   return {
									color:p.colorId,
									describe:'暂无',
									isChoose:1,
									userId:payload.userId
							   }
						   })
						   console.log('66663333')
						   dispatch('addUserFlags',arr)
					   }else{//如果检测到卖家帐号的下有旗帜，就更新旗帜
						   let list=[]
						   res.data.forEach(p => {
								state.flashPage.forEach(k => {
									if(p.color === k.colorId) {
										k.flagId=p.flagId
										k.desc=p.describe
									}
									if(p.color !== k.colorId){
										list.push({
											color:p.colorId,
											describe:'暂无',
											isChoose:1,
											userId:payload.userId
										})
									}
								})
						   							
						   })
						   config.flagList.forEach(p => {
								res.data.forEach(k => {
									if(p.colorId == k.color) {
										
										k.flagId=p.flagId
										k.desc=p.describe
									}
								})
						   							
						   })
						   console.log('list',list)
					   }
						
						console.log(state.flashPage)
						console.log('config.flagList',config.flagList)
				}else if(userPos === 'STORE') {
					let arr=[]
					   if(res.data.length === 0) {//如果检测到卖家帐号的下还没有的旗帜，就给这个用户创建旗帜
						   arr=state.flashPage.map(p => {
							   return {
									color:p.colorId,
									describe:'暂无',
									isChoose:1,
									userId:payload.userId
							   }
						   })
						   console.log('66663333')
						   dispatch('addUserFlags',arr)
					   }else{//如果检测到卖家帐号的下有旗帜，就更新旗帜
						   let list=[]
						   res.data.forEach(p => {
								state.flashPage.forEach(k => {
									if(p.color === k.colorId) {
										k.flagId=p.flagId
										k.desc=p.describe
									}
									if(p.color !== k.colorId){
										list.push({
											color:p.colorId,
											describe:'暂无',
											isChoose:1,
											userId:payload.userId
										})
									}
								})
						   							
						   })
						   config.flagList.forEach(p => {
								res.data.forEach(k => {
									if(p.colorId == k.color) {
										
										k.flagId=p.flagId
										k.desc=p.describe
									}
								})
						   							
						   })
						   console.log('list',list)
					   }
						
						console.log(state.flashPage)
						console.log('config.flagList',config.flagList)
				}
				
				
				
				
			}
		})
	},
	//增加用户的旗帜
	addUserFlags({state,commit,dispatch}, payload) {
		print
		.addUserFlags(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('增加用户旗帜',res.data)
			}
		})
	},
	
	//设置旗帜
	setOrderFlag({state,commit,dispatch}, payload) {
		print
		.setOrderFlag(payload)
		.then(res => {
			if (res.code === 200) {
				console.log('设置旗帜',res.data)
			}
		})
	},
	
	//开始准备订单数据,带参数
	startReadyOrders({state,commit,dispatch}, payload) {
		print
			.startReadyOrders(payload)
			.then(res => {
				if (res.code === 200) {
					state.aleadyGenaratedNum=[]
					let orderIds=payload.map(p => {
						return p.orderId
					})
					state.generateOrderId=orderIds
					console.log('开始准备订单数据',orderIds)
					setTimeout(() => {
						dispatch('getNewOrders',orderIds)
					},1000)
					
				}
			})
	},
	
	//点击开始生成运单号，再调此方法获取最新的订单
	getNewOrders({state,dispatch},payload) {
		print
		.getNewOrders(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('最新订单',res.data)
				console.log(state.generateOrderId)
				
				let newData=res.data
				newData.forEach(p => {
					state.generateOrderId.forEach((k,index) => {
						if(k === p.orderId && p.ready == true && p.image!== null){
							state.aleadyGenaratedNum.push(p)
							state.alreadyLoaded=true
							state.generateOrderId.splice(index,1)
						}
					})
				})
				console.log(state.generateOrderId)
				if(state.generateOrderId.length> 0){
					dispatch('getNewOrders',state.generateOrderId)
				}
				
				
				
			}
		})
	},
	
	
	storeReceived({state},payload) {
		order
		.storeReceived(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('仓库收到代打包运单',res.data)
				Message({
					message: '确认收货成功',
					type: 'success'
				})
				console.log(payload.trackingCode)
				if(res.data.length){
					state.orderList.forEach(p => {
						p.orderPackages.forEach((j,index) => {
							if(j.trackingCode == payload.trackingCode){
								console.log(index)
								j.packStatus= "RECEIVED"
							}
						
						})
						
					})
				}
			}
		})
	},
	//根据打包运单号查询订单
	getOrderByPackageTrackingCode({state,dispatch},payload) {
		order
		.getOrderByPackageTrackingCode(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('根据打包运单号查询订单',res.data)
				// let falg=res.data[0]
				// console.log('根据打包运单号查询订单',falg)
				// if(falg.orderId){
				// 	state.orderList.forEach(p => {
				// 		p.orderPackages.forEach(k => {
				// 			falg.orderPackages.forEach(j => {
				// 				if(k.trackingCode === j.trackingCode){
				// 					k.packStatus=j.packStatus
				// 				}
				// 			})
				// 		})
						
				// 	})
				// }
			}
		})
	},
	//新增代打包运单号
	addOrderPackage({state},payload) {
		order
		.addOrderPackage(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('代打印运单号',res.data)
				Message({
					message: '添加成功！',
					type: 'success'
				})
				if(res.data.orderId){
					state.orderList.forEach(p => {
						if(p.orderId === res.data.orderId){
							p.orderPackages.push(res.data)
						}
					})
				}
			}
		})
	},
	
	//删除代打包的运单号
	deleteorderpackage({state},payload) {
		order
		.deleteorderpackage(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('删除代打包的运单号',payload)
				Message({
					message: '成功删除',
					type: 'success'
				})
				
				state.orderList.forEach((p) => {
					p.orderPackages.forEach((k,index) => {
						if(k.trackingCode === payload.trackingCode){
							p.orderPackages.splice(index,1)
						}
					})
				})
			}
		})
	},
	//异步获取取件方式
	getLogisticInfo({state,commit,dispatch}, payload) {
		print
			.getLogisticInfo(payload)
			.then(res => {
				if (res.code === 200) {
					state.orderList.forEach(p => {
						if(p.orderId === payload.orderId) {
							p.logisticInfo=res.data
							if(!res.data.pickup.address_list){
								p.logisticInfo.info_needed.methods=JSON.stringify({orderId:p.orderId,type:0})
							}
							setTimeout(() => {
								state.aleadyGetlogist=true
							},1000)
						}
					})
					
					
					
					
					
					
				}
			})
	},
	//获取仓库帐号的待处理订单--高级查询页面
	getStoreOrders({state,commit,dispatch},payload){
		print
		.getStoreOrders(payload)
		.then(res => {
			if(res.code === 200) {
				state.orderList = res.data;
				state.orderPointInfo=[]
				let listTarget=[]
				console.log('仓库帐号下的待审核订单',state.orderList)
				state.loading_2=true,
				state.buttonList = [];
				for (let i = 0; i < 8; i++) {
					state.buttonList.push(new Map())
					state.activeList.push('all')
				}
				// state.activeList[2]='unsent'
				//选择店铺
				state.orderList.forEach((order) => {
				
                    state.chooseOrderId.push(order.orderId)
					if(order.flagId !== null) {
						config.flagList.forEach(p => {
							if(p.desc == '' && p.flagId== null) {
								listTarget.push(order.flagId)
								// dispatch('getFlagById',{flagId:order.flagId})
							}
						})
						
					}
					

					order.items.forEach(k => {
						state.storeItemsInfo.push({
							itemId:k.itemId,
							variationId:k.variationId,
						})
					})
					
					order.shipByDate=utils.renderTimeDate(order.shipByDate)
					let shopIdMap = state.buttonList[0];
					let shopIdList = shopIdMap.get(order.storeId);
					if (shopIdList == null || shopIdList == "undifined") {
						shopIdList = [];
					}
					shopIdList.push(order);
					shopIdMap.set(order.storeId, shopIdList)
					state.buttonList[0] = shopIdMap;
					
				})
				
				listTarget=Array.from(new Set(listTarget))
				if(listTarget.length){
					listTarget.forEach(i => {
						dispatch('getFlagById',{flagId:i})
					})
				}
				
				console.log('listTarget',listTarget)

				dispatch('getStoreItem',state.storeItemsInfo)
			   

				let list = [];
				let flag = true;
				let firstShopId=0;
				state.buttonList[0].forEach((value, key) => {
					if(firstShopId==0){
						firstShopId=key
					}
					let active = (key == firstShopId)
					if (active == true) {
						flag = false
					}
					list.push({
						'key': key,
						'value': value,
						'isActive': active
					})
				})
				if (flag) {
					list[0].isActive = true;
				}
				state.buttonMapList.push(list);
				console.log('asfdsafg a', state.buttonList);
				commit(SET_TTP, {
					orders: state.buttonList[0].get(firstShopId),
					// orders:state.buttonList[2].get('unsent'),
					index: 0
				})
				
			}
		})
	},
	
	
	//印尼用户扫描打包出库
	printMergerOrders({state,dispatch},payload){
		print
		.printMergerOrders(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('合并打印订单',res.data)
				if(res.data){
					state.error_list=res.data.errorOrder
					state.success_list=res.data.successOrder
					state.orderUrl=res.data.successUrl
					state.totalNum=payload.length
				}
			}
		})
	},
	//印尼用户扫描打包出库
	setPackaged({state},payload){
		print
		.setPackaged(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('扫描打包出库',res.data)
				state.packagelist=[]
				state.packagelist.push(res.data)
				console.log('扫描打包出库',state.packagelist)
				state.buttonMapList[7].forEach(p => {
					if(p.isActive){
						p.value.forEach(k => {
							if (k.orderId == res.data.orderId) {
								k.packaged = true
							}
						})
					}
				})
				Message({
					message: '订单成功出库！',
					type: 'success'
				})
				state.falg=true
			}else{
				Message({
					message: res.msg,
					type: 'error'
				})
				state.falg=true
			}
		})
	},
	
	//安排订单
	arrangement({
		state,
		commit,
		dispatch
	}, payload) {
		print
			.arrangement(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('安排订单',res.data)
					state.aleadyGenaratedNum=[]
					let orderIds=payload.map(p => {
						return p
					})
					state.generateOrderId=orderIds
					console.log('开始准备订单数据',orderIds)
					setTimeout(() => {
						dispatch('getNewOrders',orderIds)
					},1000)

				}
			})
	},
	//增加打印次数
	addPrintNum({
		state,
		commit
	}, payload) {
		print
			.addPrintNum(payload)
			.then(res => {
				if (res.code === 200) {
					console.log('增加了打印次数')

				}
			})
	},

	//卖家获取所有待处理的订单
	getAllOrders({
		state,
		dispatch,
		commit
	}, payload) {
		print
			.getAllOrders(payload)
			.then(res => {
				if (res.code === 200) {
					state.loading=false
					state.loading_2=true
					if(!res.data.length){
						
						state.buttonMapList = []
						return
					}
					console.log('获取所有订单1', res.data)
					state.shopIds=[]
					state.orderPointInfo=[]
					state.chooseOrderId=[]
					
					state.orderList = res.data;
					state.orderList2=res.data
					let shopIds=utils.getAllshop().map(p => {return p.value}).slice(1)
					//设置订单在不设置安排时间下的情况下，默认为隔天安排
					commit(SET_SECONDE_PICKTIME)
					state.buttonList = [];
					for (let i = 0; i < 9; i++) {
						state.buttonList.push(new Map())
						state.activeList.push('all')
					}
					
					//选择店铺
					state.orderList.forEach((order,index) => {
						state.chooseOrderId.push(order.orderId)
						// if(order.sent == false && order.trackingNo === ''){
						// 	dispatch('getLogisticInfo',{orderId:order.orderId,shopId:order.shopId})
						// }
						order.items.forEach(k => {
							state.storeItemsInfo.push({
								itemId:k.itemId,
								variationId:k.variationId,
							})

						})
						
						
						
						order.shipByDate=utils.renderTimeDate(order.shipByDate)
						let shopIdMap = state.buttonList[0];
						let shopIdList = shopIdMap.get(order.shopId);
						if (shopIdList == null || shopIdList == "undifined") {
							shopIdList = [];
						}
						shopIdList.push(order);
						shopIdMap.set(order.shopId, shopIdList)
						state.buttonList[0] = shopIdMap;
					})
				
			        
					dispatch('getStoreItem',state.storeItemsInfo)
					dispatch('getGoodsType',state.chooseOrderId)
					if(state.buttonList[0].get(payload.shopIds[0]) == undefined && !payload.mutilChoose) {
						state.buttonMapList=[]
						return
					}
					let allOrder=[]
					if(payload.mutilChoose){
						console.log('allorder',state.buttonList[0])
						state.buttonList[0].forEach((key,value) => {
							
							key.forEach(j => {
								allOrder.push(j)
							})
						})
						console.log('allorder',allOrder)
					}
					commit(SET_TTP, {
						
						orders:allOrder.length ? allOrder : state.buttonList[0].get(payload.shopIds[0]),
						index: 0
					})



				}
			})
	},

}

const mutations = {
	[SET_ITEMS]: (state) => {
		state.pendingprocess = []
		state.arr.forEach(p => {
			state.pendingprocess.push(p)
		})

	},
	[SET_TTP]: (state, data) => {
		console.log(data.orders)
		console.log(data.index)
		let index = data.index
		let orderList = [];
		
		if (index > 0) {
			console.log(state.buttonList)
			orderList = state.buttonList[index].get(data.orders)
		} else {
			orderList = data.orders
		}
		console.log(orderList)
		for (let i = index + 1; i < 9; i++) {
			state.buttonList[i] = new Map();
			if (i > 0) {
				state.buttonList[i].set("all", orderList)
			}
		}
		let ftt=true
		if(ftt){
			orderList.forEach((order) => {
				//选择仓库
				if (index < 1) {
					let storeIdMap = state.buttonList[1]
					let storeList = storeIdMap.get(order.storeId)
					if (storeList == null || storeList == "undifined") {
						storeList = [];
					}
					storeList.push(order);
					storeIdMap.set(order.storeId, storeList)
					state.buttonList[1] = storeIdMap;
				}
				//加载状态
				if (index < 2) {
					
					let loadStatusMap = state.buttonList[2]
					let orderkey=order.sent ? (order.ready?'ready':'unready') :'unsent'
					let loadStatusList = loadStatusMap.get(orderkey)
					
					if (loadStatusList == null || loadStatusList == "undifined") {
						loadStatusList = [];
					}
					loadStatusList.push(order);
					loadStatusMap.set(orderkey, loadStatusList)
					state.buttonList[2] = loadStatusMap;
				}
				//打印状态
				if (index < 3) {
					let printStatusMap = state.buttonList[3]
					let printStatusList = printStatusMap.get(order.printed)
					if (printStatusList == null || printStatusList == "undifined") {
						printStatusList = [];
					}
					printStatusList.push(order);
					printStatusMap.set(order.printed, printStatusList)
					state.buttonList[3] = printStatusMap;
				}
				//物流类型
				if (index < 4) {
					let logisticsStatusMap = state.buttonList[4]
					let logisticsStatusList = logisticsStatusMap.get(order.logistics)
					if (logisticsStatusList == null || logisticsStatusList == "undifined") {
						logisticsStatusList = [];
					}
					logisticsStatusList.push(order);
					logisticsStatusMap.set(order.logistics, logisticsStatusList)
					state.buttonList[4] = logisticsStatusMap;
				}
				
				//旗帜标注
				if (index < 5) {
					let shipbydateMap = state.buttonList[5]
					let shipbydateList = shipbydateMap.get(order.flagId)
					if (shipbydateList == null || shipbydateList == "undifined") {
						shipbydateList = [];
					}
					shipbydateList.push(order);
					shipbydateMap.set(order.flagId, shipbydateList)
					
					state.buttonList[5] = shipbydateMap;
					
				}
				
				//最后发货
				if (index < 6) {
					let shipbydateMap = state.buttonList[6]
					let shipbydateList = shipbydateMap.get(order.shipByDate)
					if (shipbydateList == null || shipbydateList == "undifined") {
						shipbydateList = [];
					}
					shipbydateList.push(order);
					shipbydateMap.set(order.shipByDate, shipbydateList)
					
					state.buttonList[6] = shipbydateMap;
					
				}
				//订单状态 
				if (index < 7) {
					let orderStatusMap = state.buttonList[7]
					let orderStatusList = orderStatusMap.get(order.orderStatus)
					if (orderStatusList == null || orderStatusList == "undifined") {
						orderStatusList = [];
					}
					orderStatusList.push(order);
					orderStatusMap.set(order.orderStatus, orderStatusList)
					state.buttonList[7] = orderStatusMap;
				}
				//sku状态
				if (index < 8) {
					let skuQuantityMap = state.buttonList[8]
					let skuQuantityList = skuQuantityMap.get(order.itemNum == 1 ? "oneSku" : "someSku")
					if (skuQuantityList == null || skuQuantityList == "undifined") {
						skuQuantityList = [];
					}
					skuQuantityList.push(order);
					skuQuantityMap.set(order.itemNum == 1 ? "oneSku" : "someSku", skuQuantityList)
					state.buttonList[8] = skuQuantityMap;
				}
			
			
			})
			console.log(state.buttonList)
			
			for (let j = 1; j < 8; j++) {
				state.buttonMapList[j] = null
			}
			state.buttonMapList.length = 1
			
			state.buttonList.forEach((map, i) => {
				let list = [];
				let flag = true;
				if (i != 0 ) {
					map.forEach((value, key) => {
						let active = (key == state.activeList[i])
						if (active == true) {
							flag = false
						}
						list.push({
							'key': key,
							'value': value,
							'isActive': active
						})
					})
					if (flag) {
						list[0].isActive = true;
					}
					state.buttonMapList.push(list);
				}
			})
			    let un_sent=null
			    for (var i = 0; i < state.buttonMapList[2].length; i++) {
			      if (state.buttonMapList[2][i].key == 'unsent') {
			         un_sent=i;
			      }
			    }
			if(un_sent === null){
				state.buttonMapList[2].push({
					isActive:false,
					key:'unsent',
					value:[]
				})
			}
			state.buttonMapList[5].sort((a,b) => {
				return a.key<b.key ? -1 : 1 
			})
			state.buttonMapList[6].sort((a,b) => {
				return a.key>b.key ? -1 : 1 
			})
			state.isDone=true
			console.log('buttonMapList', state.buttonMapList);
			console.log('buttonList', state.buttonList);
		}else{
			state.isDone=true
			state.buttonMapList.forEach((p,index) => {
				if(index >2){
					p=[{
						isActive:true,
						key:"all",
						value:[]
					}]
				}
			})
			
		}
	},
	[SET_HAS_PRINTED]: (state, arr) => {
		let list = []
		state.orderList.forEach(p => {
			arr.forEach(j => {
				if (p.orderId == j) {
					p.printed = true
					list.push(p)
				}
			})
		})
		console.log('hfjnvhfjkv', list)
		console.log('hfjnvhfjkv', state.orderList)
	},
	
	[SET_HAS_PRINTED_READY]: (state, arr) => {
		let list = []
		state.orderList.forEach(p => {
			arr.forEach(j => {
				if (p.orderId == j) {
					p.sent = true
					list.push(p)
				}
			})
		})
	},
	[SET_SECONDE_PICKTIME]:(state) => {
		state.orderList.forEach(p =>{
			if(p.logisticInfo !== null){
				if(p.logisticInfo.pickup.address_list.length > 0){
					p.logisticInfo.pickup.address_list.forEach(k => {
						if(k.address_flag.indexOf('pickup_address') > -1) {
							if(k.time_slot_list instanceof Array ){
								p.logisticInfo.info_needed.methods=JSON.stringify({orderId:p.orderId,pickupTimeId:k.time_slot_list.length >0 ? k.time_slot_list[0].pickup_time_id: '',addressId:k.address_id,type:1})
							}else if(k.time_slot_list instanceof Object && k.time_slot_list.error ==="error_expired"){
								p.logisticInfo.info_needed.methods=JSON.stringify({orderId:p.orderId,type:0})
							}
						}
					})
				}
					
			}
		})
	},
	[INIT_DATA]:(state) => {
		state.success_list=[],
		state.error_list=[],
		state.orderUrl='',
		state.totalNum=0,
		state.falg=false
		state.alreadyLoaded=false
	},
	[FAST_PRINT]:(state,arr) => {
		state.success_list=arr
		state.totalNum=arr.length
		state.orderUrl=true
	},
	[UPDATA_PAGE]:(state,list) => {//储存获取到的旗帜
		state.flashPage=list
		console.log(state.flashPage)
	},
	[SHOW_LOADING]:(state) => {
		state.loading=true
	},
	[SET_LOGISTIC_FALSE]:(state) => {
		state.aleadyGetlogist=false
	},
	[SENT_PPT]:(state,arr) => {
		state.fastPrintList=arr
		console.log(state.fastPrintList)
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
